<template>
  
  <ellipse 
    class   = "ellipse"
    :style  = "style"
    :cx     = "shape.cx"
    :cy     = "shape.cy"
    :rx     = "shape.rx"
    :ry     = "shape.ry"

    @contextmenu.prevent = "$emit('contextmenu', $event)"
    @mousedown.prevent   = "$emit('mousedown', $event);"
  />

</template>

<script>

/*
 * This class is named "elliptical" because "ellipse" is the name of an existing
 * html element (more accurately, the svg element this component wraps).
 */

export default {

  // #region Properties

  props: {
    shape: Object
  },
  computed: {
    style() {
      return {
        'fill':          'transparent',
        'vector-effect': 'non-scaling-stroke',
        'stroke':        this.shape.color,
        'stroke-width':  '4'
      }
    }
  }

  // #endregion Properties

}

</script>